import store from '../store'
import Vue from 'vue';

export default async (to, from, next) => {

    if (!store.getters['auth/check']) {

        // if a token is returned through the route by SKY SMS
        if (to.query._token != null) {
                // Save the token.
                store.dispatch('auth/saveToken', {
                token: to.query._token,
                remember: true
            })

            // Fetch the user.
            store.dispatch('auth/fetchUser')

            next();

            // if a error is returned through the route by SKY SMS
        } else if (to.query.error_n) {

            Vue.prototype.$q.notify({
                color: 'warning',
                icon: 'warning',
                message: to.query.message,
                detail: "",
                position: 'top'
            })


             next({name: "home"})

        } else {
            Vue.prototype.$login(to.path.replace("/", "*").replace("/", "*"))

        }

    //User already logged in
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js